// extracted by mini-css-extract-plugin
export default {"cSelect":"CustomSelect_cSelect__HfGfe","cItems":"CustomSelect_cItems__UuS-5","coverLayer":"CustomSelect_coverLayer__UAJf4","detailsLink":"CustomSelect_detailsLink__E0bpk"};